import React, {useEffect, useState} from 'react';
import {NavLink, Link, useLocation} from 'react-router-dom';
import {getToken} from '../../lib/api';
import styles from './AppHeader.module.scss';

const NAV = [
    {to: '/', label: '学习', end: true},
    {to: '/quests', label: '任务地图'},
    {to: '/gallery', label: '作品广场'},
    {to: '/profile', label: '我的主页'}
];

export default function AppHeader () {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [loggedIn, setLoggedIn] = useState(Boolean(getToken()));

    useEffect(() => {
        const sync = () => setLoggedIn(Boolean(getToken()));
        window.addEventListener('cq-auth-change', sync);
        window.addEventListener('storage', sync);
        return () => {
            window.removeEventListener('cq-auth-change', sync);
            window.removeEventListener('storage', sync);
        };
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (!open) return undefined;
        const closeOnEscape = e => {
            if (e.key === 'Escape') setOpen(false);
        };
        window.addEventListener('keydown', closeOnEscape);
        return () => window.removeEventListener('keydown', closeOnEscape);
    }, [open]);

    return (
        <header className={styles.header}>
            <div className={`cq-container ${styles.inner}`}>
                <Link to="/" className={styles.brand} aria-label="CodeQuest 首页">
                    <span className={styles.logoMark}>{'</>'}</span>
                    <span className={styles.logoText}>CodeQuest</span>
                </Link>

                <button
                    type="button"
                    className={styles.burger}
                    aria-label={open ? '关闭菜单' : '打开菜单'}
                    aria-controls="primary-navigation"
                    aria-expanded={open}
                    onClick={() => setOpen(o => !o)}
                >
                    <span /><span /><span />
                </button>

                <nav id="primary-navigation" className={[styles.nav, open ? styles.navOpen : ''].join(' ')} aria-label="主导航">
                    {NAV.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            className={({isActive}) => [styles.link, isActive ? styles.active : ''].join(' ')}
                            onClick={() => setOpen(false)}
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className={styles.actions}>
                    {loggedIn ? (
                        <Link to="/profile" className={styles.avatar} aria-label="我的主页">
                            <span>码</span>
                        </Link>
                    ) : (
                        <Link to="/login" className={styles.loginLink}>登录</Link>
                    )}
                </div>
            </div>
        </header>
    );
}
